import React, { Component } from 'react';
import axios from 'axios';

import { getSessionId, getSelectedPromocode } from '../../utils/SettingsRetriever';
import request from '../../utils/request';

import moment from 'moment';

import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Popper from '@material-ui/core/Popper';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import CircularProgress from '@material-ui/core/CircularProgress';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';

import SpotlioIcon from '../../components/Icon';

import ListGroups from '../../components/List/Activities/groups';
import SearchingScreen from '../../components/Layout/SearchingScreen';
import Currency from '../../components/Currency';
import SEO from '../../components/Seo';
import Modal from '../../components/Modal';
import Dialog from '../../components/Dialog';
import TabGenerator from '../../components/Layout/HeaderTabs/TabGenerator';
import TotalDueNow from '../../components/TotalDueNow';
import Products from '../../components/List/Cart/products';
import NumericStepper from '../../components/NumericStepper';
import QuantitySelector from '../../components/QuantitySelector';
import TextField from '../../components/TextField';
import Breadcrumb from '../../components/Breadcrumb';
import SpotlioButton from '../../components/Button';

import { getSystemSettings, setSessionId, setCartLength } from '../../utils/SettingsRetriever';
import { getCookie } from '../../utils/CookiesRetriever';
import SalesIDRetriever from '../../utils/SalesIDRetriever';
import QueryStringRetriever from '../../utils/QueryStringRetriever';
import { getBundle, updateBundleAmount, toggleBundleModal, addBundleProducts, addBundleToCart } from '../../utils/Bundle';
import LocaleAsString from '../../LocaleEngine/LocaleAsString';
import IntlMessage from '../../LocaleEngine';
import { GAPageView, pushDataLayer } from '../../utils/ga';

import { getItinerary as globalGetItinerary, add as cartServiceAdd, addPackage as globalAddPackage, remove as globalRemove } from '../../services/cart';
import { getCheckoutEntrypoint } from '../../helpers/urls';

import PushHistory from '../../utils/PushHistory';
// import history from '../../history';

import './index.scss';

let CancelToken = axios.CancelToken;
let source = CancelToken.source();

export default class Cart extends Component{
    constructor(props){
        super(props);
        this.state = {
            cart:[],
            loading:true,
            total: 0,
            taxes: 0,
            taxesList: [],
            deletedItem:{},
            deletedPackage:{},
            itineraryId: 0,
            categories: getSystemSettings(),
            taxesModal: false,
            removeItemModal: false,
            removePackageModal: false,
            itinerarySaved: false,
            itinerarySavedDiag: false,
            b2bCookie: JSON.parse(getCookie('b2b')),
            saveItineraryMenuDisplay: false,
            saveItineraryMenuSelectedIndex: 0,
            needGuest: false,
            savings: 0,
            amountToDelete: undefined,
            bundleObject: {
                bundles: [],
                bundleModal : [],
                currentIndexModal: null,
                productNameBundle: undefined,
                incorrectAmount: false
            },
            loadingBundle: false,
            selectedPackage: {},
            promocodeForm: {
                code: '',
                added: false,
                error: false
            },
            steps: {
                list: [ 'Shopping Cart', 'Guest Info', 'Payment Info', 'Review', 'Confirm' ],
                current: 1
            },
            b2cSaveItinerary: false,
            b2cSaveItineraryForm: {},
            b2cSaveItineraryLoading: false,
            successfullySavedB2CItinerary: false,
            loadingSaveItinerary: false,
            open: null
        }

        const query = QueryStringRetriever();
        if(query.needGuest){
            this.state.needGuest = true;
        }
    }

    triggerModalEvent = () => {
        // eslint-disable-next-line
        if ( typeof CustomEvent !== "function" ) CustomEvent = ( event, params ) => {
            params = params || { bubbles: false, cancelable: false, detail: null };
            var evt = document.createEvent( 'CustomEvent' );
            evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
            return evt;
        }

        var event = new CustomEvent("triggerAttachGuestsModal");
        document.dispatchEvent(event);
    }

    handleFormChange = (name, form) => event => {
        let state = this.state;
        state[form] = {...state[form], [name]: event.target.value, error: ''}
        this.setState(state);
    };

    componentDidMount(){
        this.getItinerary();
    }

    pageView() {
        let layer = {
            itineraryid: this.state.itineraryId,
            subtotal: this.state.total,
            tax: this.state.taxes,
            total: (this.state.total + this.state.taxes),
            result: 'OK',
            products: []
        };

        this.state.cart.forEach((products) => {
            products.items.forEach((item) => {
                layer.products.push({
                    itineraryItemId: item.ItineraryItemId,
                    sku: item.SKU,
                    name: item.ProductName,
                    category: item.CategoryName,
                    price: parseFloat(item.Price),
                    quantity: item.Quantity,
                    arrival_date: item.ArrivalDate,
                    departure_date: item.DepartureDate,
                    _PackageID: item.PackageId,
                    _PackageName: item.PackageName,
                    _AssociatedItineraryItemID: item.ParentItemId,
                });
            })
        });

        if(this.props.readOnly) {
            GAPageView({
                globalSettings: getSystemSettings(),
                sectionSettings: {
                    type: 'completed-booking'
                },
                sessionId: getSessionId(),
                data: layer
            });

            pushDataLayer({
                globalSettings: getSystemSettings(),
                event: 'purchase',
                data: {
                    transactionId: ''+layer.itineraryid+'',
                    transactionAffiliation: '',
                    transactionTotal: parseFloat(layer.subtotal),
                    transactionTax: parseFloat(layer.tax),
                    transactionShipping: 0,
                    transactionProducts: layer.products
                }
            });
        }else{
            GAPageView({
                globalSettings: getSystemSettings(),
                sectionSettings: {
                    type: 'cart'
                },
                sessionId: getSessionId(),
                data: layer
            });
        }
    }

    toggleSupplier = (index) => {
        if ( index === this.state.open){
            this.setState({open: null})
        } else {
            this.setState({open: index})
        }
    }

    getItinerary = (action = false) => {
        let params = { bundle: 1};

        if(action === 'delete' || action === 'add'){
            params.reload = true;
        }

        globalGetItinerary(params)
        .then( (response) => {
            let state = {...this.state};
            state.loading = false;
            if (response.items){
                let selectedPackage = this.state.selectedPackage
                const cart = response.items;
                const taxes = response.fees;
                let taxesfees = 0
                let total = 0
                let savings = 0
                cart.forEach((agrupation, idx) => {
                    agrupation.items.forEach((item) => {
                        total += parseFloat(item.Price);
                        savings += parseFloat(item.OriginalPrice - item.Price)
                    })
                })
                taxes.forEach((tax) => {
                    tax.Amount ? taxesfees += tax.Amount : taxesfees += tax.price
                })

                if (response.selectedPackage){
                    selectedPackage = response.selectedPackage
                }
                state = {...state, total: total, savings: savings, taxes:taxesfees, loading: false, cart: cart, taxesList: taxes.sort(this.compareTax), loadingBundle: false, selectedPackage: selectedPackage, bundleObject: toggleBundleModal(this.state.bundleObject, false)};
                if (cart.length > 0) {
                    state.itineraryId = response.itineraryid;
                    state.reserved = response.reserved;
                }
            }
            if (action === 'add'){
                state.addMoreModal = false;
            }

            this.setState(state);
            this.pageView();
        });
    }

    getBundle(productBundle){
        this.setState({loadingBundle: true}, () => {
            getBundle(productBundle).then(r => {
                if(!r){return;}
                this.setState({...this.state, bundleObject: r, loadingBundle: false});
            });
        })
    }

    addToPackage(element, amount, callback){
        let itineraryItems = [];
        let itineraryItem = {
            ArrivalDate: this.state.modalComponent.SearchDate,
            DepartureDate: this.state.modalComponent.SearchDate,
            AdultCount: 1,
            ChildCount: 0,
            SupplierId: element.SupplierId,
            ProductId: element.ProductId,
            Quantity: amount,
            PackageComponentId: this.state.modalComponent.ComponentId
        }

        itineraryItems.push(itineraryItem)

        globalAddPackage({
            itineraryitems: JSON.stringify(itineraryItems),
            packageId: this.state.selectedPackage.PackageId
        })
        .then(response =>{
            this.getItinerary('add');
        })
    }

    addToCart(element, amount, callback){
        let items = [];
        let item = {
            ArrivalDate: element.ArrivalDate,
            DepartureDate: element.DepartureDate,
            AdultCount: 1,
            ChildCount: 0,
            SalesId: SalesIDRetriever(),
            SupplierId: element.SupplierId,
            ProductId: element.ProductId,
            Quantity: amount,
            hasTotalPrice: true,
        }
        items.push(item);
        cartServiceAdd({
            itineraryitems: JSON.stringify(items)
        })
        .then(() =>{
            this.getItinerary('add');
        }).then(callback)
    }

    compareTax = (a, b) => {
        if (!a.Amount){
            if (a.price < b.Amount) {
                return -1;
            }
            if (a.price > b.Amount) {
                return 1;
            }
        } else if(!b.Amount) {
            if (a.Amount < b.price) {
                return -1;
            }
            if (a.Amount > b.price) {
                return 1;
            }
        }
        else {
            if (a.Amount < b.Amount) {
                return -1;
            }
            if (a.Amount > b.Amount) {
                return 1;
            }
        }

        return 0;
    }

    gotoRegister = () => {
        this.setState({...this.state, loadingPayment: true}, () => {
            if (JSON.parse(getCookie('b2b'))){
                request({
                    url: getSystemSettings().api + '/inntopia/travel-agent/guest/current',
                    method: 'POST',
                    data: {
                        token: JSON.parse(getCookie('b2b')).token.token,
                        salesId: SalesIDRetriever(),
                    }
                }).then(response => {
                    if (response.status === 200){
                        PushHistory('/checkout/payment')
                    } else {
                        this.setState({...this.state, loadingPayment: false}, () => this.triggerModalEvent());
                    }
                })
            } else {
                PushHistory(getCheckoutEntrypoint())
            }
        });
    }

    componentWillReceiveProps(nextProps){
        if (nextProps.loading === true && this.state.loading === false){
            this.setState({loading: nextProps.loading})
        }
        if (nextProps.loading === 'finished' && this.state.loading !== 'finished'){
            this.getItinerary();
        }
    }

    removeItemModalOpen = (item, value) => {
        this.setState({deletedItem: item}, () => {
            this.setState({removeItemModal: value, amountToDelete: value === false ? undefined : 1})
        })
    }

    removePackageModalOpen = (Package, value) => {
        this.setState({deletedPackage: Package}, () => {
            this.setState({removePackageModal: value})
        })
    }

    taxesModalOpen = (value) => {
        if(this.state.taxes > 0) {
            this.setState({...this.state, taxesModal: value});
        }
    }

    handleDeleteItem = (quantity) => {
        this.setState({loading: true, removeItemModal: false})
        if (quantity){
            for (let i = 0; i < quantity; i++){
                globalRemove({
                    itemId: this.state.deletedItem.ItineraryItemsIds[i]
                })
                .then( () => {});
            }
            this.getItinerary('delete');
        } else {
            globalRemove({
                itemId: this.state.deletedItem.ItineraryItemId
            })
            .then( () => {
                this.getItinerary('delete');
            });
        }
    }

    handleDeletePackage = () => {
        this.setState({loading: true, removePackageModal: false})
        let packageId = this.state.deletedPackage.items[0].PackageId
        this.state.cart.forEach((products) => {
            products.items.forEach((item) => {
                if (item.PackageId === packageId){
                    let requests = item.ItineraryItemsIds.map(id => {
                        return this.removeItemFromCart(id).catch(function(error){console.error(error)});
                    });
                    Promise.all(requests)
                    .then( () => {
                        // setCartLength(getCartLength() - this.state.deletedItem.Quantity)
                        this.getItinerary('delete');
                    });
                }
            })
        })
    }

    removeItemFromCart = (id) => {
        return new Promise((resolve, reject) => {
            globalRemove({
                itemId: id
            })
            .then( () => {
                resolve(true);
            })
            .catch(() => {
                reject(false);
            });
        });
    }

    saveItinerary = (nextAction) => {
        if(this.state.b2bCookie || getSystemSettings().app.cart.continueShopping){
            if (nextAction === 'Continue Shopping') {
                const selectedPromocode = getSelectedPromocode();
                const pkgName = selectedPromocode.name.toLowerCase().replace(/\*\s?/g, '').replace(/[&\\#,+()$~%@.'"/:?<>{}!¡]/g,'').replace(/[-\s_]/g, '-').replace(/--+/g, '-').replace(/-$/, '');
                PushHistory('/packages/' + pkgName + '/' + selectedPromocode.inntopiaPackageId + '?ref=cart')
                return true;
            } else {
                this.setState({...this.state, loadingSaveItinerary: true}, () => {
                    request({
                        url: getSystemSettings().api + '/inntopia/travel-agent/guest/current',
                        method: 'POST',
                        data: {
                            token: this.state.b2bCookie.token.token,
                            salesId: SalesIDRetriever()
                        }
                    })
                    .then( (result) => {
                        this.setState({...this.state, loadingSaveItinerary: false}, () => {
                            if(result.status === 200){
                                request({
                                    url: getSystemSettings().api + '/inntopia/cart/save',
                                    method: 'POST',
                                    data: {
                                        sessionId: getSessionId(),
                                        salesId: SalesIDRetriever()
                                    }
                                })
                                .then( (data) => {
                                    if (data.status === 200){
                                        // this.setState({itinerarySaved: true});
                                        switch(nextAction) {
                                            case 'Save & Checkout':
                                                PushHistory('/checkout/payment');
                                                break;
                                            case 'Save & Continue':
                                                this.setState({...this.state, itinerarySavedDiag: true});
                                                break;
                                            case 'Save & Close':
                                                this.regenerateSessionAndRedirect();
                                                break;
                                            default:
                                                break;
                                        }
                                    }
                                });
                            }else{
                                this.triggerModalEvent();
                            }
                        })
                    });
                })
            }
        }else{
            if (!this.state.b2cSaveItineraryForm.email) {
                return null;
            } else {
                if (this.state.b2cSaveItineraryError || this.state.successfullySavedB2CItinerary) {
                    this.setState({
                        ...this.state,
                        b2cSaveItineraryError: false,
                        successfullySavedB2CItinerary: false,
                        b2cSaceItinerary: false,
                        b2cSaveItineraryLoading: false
                    });
                } else {
                    this.setState({
                        ...this.state,
                        b2cSaveItineraryLoading: true
                    }, () => {
                        request({
                            url: 'https://vvdb2732de.execute-api.us-east-1.amazonaws.com/send',
                            method: 'POST',
                            data: {
                                sessionid: getSessionId(),
                                salesid: SalesIDRetriever(),
                                itineraryid: this.state.itineraryId,
                                ...this.state.b2cSaveItineraryForm
                            }
                        }).then(response => {
                            if (response.data) {
                                this.setState({
                                    ...this.state,
                                    successfullySavedB2CItinerary: true,
                                    b2cSaveItineraryLoading: false,
                                    b2cSaveItineraryForm: {}
                                });
                            } else {
                                throw Error();
                            }
                        }).catch(err => {
                            this.setState({
                                ...this.state,
                                b2cSaveItineraryError: 'Could not save itinerary',
                                b2cSaveItineraryLoading: false,
                                b2cSaveItineraryForm: {}
                            });
                        });
                    })
                }
            }
        }
    }

    regenerateSessionAndRedirect = () => {
        request({
            url: getSystemSettings().api + '/inntopia/session?salesid=' + SalesIDRetriever(),
            method: 'GET'
        })
        .then( (result) => {
            setSessionId(result.data.SessionId);
            setCartLength(0)
            PushHistory('/b2b/dashboard');
        });
    }

    handleSaveItineraryButtonClick = (index) => {
        this.saveItinerary(index);
    }

    handleSaveItineraryMenuDisplay = (state) => {
        if (!state) state = !this.state.saveItineraryMenuDisplay;
        this.setState({...this.state, saveItineraryMenuDisplay: state});
    }

    getPackageUpselling = (component, componentData) => {
        let { PackageId, ComponentId } = component;

        let selectedPromocode = getSelectedPromocode();

        this.setState({loadingAddMore: true, addMoreModal: true, modalComponent: {...this.state.modalComponent, ComponentName: component.ComponentName}}, () => {
            let url = getSystemSettings().api + '/packages/package?id=' + getSystemSettings().id + '&salesId=' + SalesIDRetriever() + '&packageId=' + PackageId + '&startDate=' + moment.utc(componentData.arrival).format("YYYY-MM-DD") + '&endDate=' + moment.utc(componentData.departure).format("YYYY-MM-DD") + '&adultCount=' + componentData.adults + '&childCount=' + componentData.children + '&onlyComponent=' + ComponentId;
            if(componentData.code !== undefined && componentData.code !== '' && componentData.code !== null) {
                url += '&code=' + componentData.code;
            } else if (selectedPromocode && selectedPromocode.inntopiaPackageId === PackageId){
                url += '&code=' + selectedPromocode.inntopiaCode;
            }

            request({
                url: url,
                method: 'GET',
                cancelToken: source.token
            }).then((result) => {
                let modalComponent = {}
                if (result.data.result){
                    result.data.result.Components.forEach( (item) => {
                        if (item.ComponentId === ComponentId){
                            modalComponent = item
                        }
                    })
                }
                this.setState({...this.state, loadingAddMore: false, modalComponent: modalComponent });
            })
        })
    }

    toggleAddMore = (value) => {
        this.setState({addMoreModal: value});
    }

    applyPromocode = () => {
        request({
            url: getSystemSettings().api + '/inntopia/cart/setPromocode',
            method: 'POST',
            data: {
                id: getSystemSettings().id,
                sessionId: getSessionId(),
                salesId: SalesIDRetriever(),
                packageCode: this.state.promocodeForm.code
            }
        }).then((result) => {
            let state = this.state;
            if(result.data.PackageId){
                state.loading = true;
                state.promocodeForm.added = true;
                state.promocodeForm.error = false;
                this.setState(state, () => {
                    this.getItinerary('add');
                });
            }else{
                state.promocodeForm.error = true;
                this.setState(state);
            }
        })
    }

    renderSaveItineraryButton = (b2bOnly = false, position = null) => {
        if (this.state.b2bCookie) {
            const options = [
                'Save & Checkout',
                'Save & Continue',
                'Save & Close',
                'Continue Shopping'
            ];
            if (!b2bOnly) return (
                <React.Fragment>
                    <ButtonGroup className="SaveItineraryButton" variant="contained" aria-label="split button">
                        <SpotlioButton loading={this.state.loadingSaveItinerary} onClick={() => this.handleSaveItineraryButtonClick(options[0])}>{options[0]}</SpotlioButton>
                        <SpotlioButton
                            color="primary"
                            variant="contained"
                            size="small"
                            className="SaveItineraryArrow"
                            aria-owns={this.state.saveItineraryMenuDisplay ? 'menu-list-grow' : undefined}
                            aria-haspopup="true"
                            onClick={() => this.handleSaveItineraryMenuDisplay(true)}
                        >
                            <SpotlioIcon color="#FFFFFF" icon="feather-chevron-down" />
                        </SpotlioButton>
                        </ButtonGroup>
                        <Popper className="SaveItineraryOptions" open={this.state.saveItineraryMenuDisplay} transition disablePortal>
                        {({ TransitionProps, placement }) => (
                            <Grow
                            {...TransitionProps}
                            style={{
                                transformOrigin: "bottom"
                            }}
                            >
                            <Paper id="menu-list-grow">
                                <ClickAwayListener onClickAway={() => this.handleSaveItineraryMenuDisplay(false)}>
                                    <MenuList>
                                        {options.map((option, index) => (
                                        <MenuItem
                                            key={option}
                                            selected={index === this.state.saveItineraryMenuSelectedIndex}
                                            onClick={() => this.handleSaveItineraryButtonClick(options[index])}
                                        >
                                            {option}
                                        </MenuItem>
                                        ))}
                                    </MenuList>
                                </ClickAwayListener>
                            </Paper>
                            </Grow>
                        )}
                        </Popper>
                </React.Fragment>
            );
        } else {
            const saveItinerary = getSystemSettings().app.cart.saveItinerary;
            const continueShopping = getSystemSettings().app.cart.continueShopping;
            
            if (saveItinerary) {
                if ((position === 'top' && saveItinerary.top === true) || (position === 'bottom' && saveItinerary.bottom === true)) {
                    return <Button className="save" onClick={() => this.handleOpenB2CSaveItinerary(true)}>Save itinerary</Button>
                } else return null;
            } else if (continueShopping) {
                return <Button className="continue" onClick={() => this.handleSaveItineraryButtonClick("Continue Shopping")}>Continue shopping</Button>
            };
        }
    }

    handleCloseItinerarySavedDiag = () => {
        this.setState({...this.state, itinerarySavedDiag: false});
    }

    handleOpenB2CSaveItinerary = (val) => {
        this.setState({
            ...this.state,
            b2cSaveItinerary: val,
            successfullySavedB2CItinerary: false,
            b2cSaveItineraryLoading: false,
            b2cSaveItineraryError: false,
            b2cSaveItineraryForm: {},
        });
    }

    handleB2CSaveItineraryInput = (event) => {
        let b2cForm = this.state.b2cSaveItineraryForm;
        b2cForm[event.target.name] = event.target.value;
        this.setState({...this.state, b2cSaveItineraryForm: b2cForm});
    }

    handleRenderSaveItineraryModalContent = () => {
        if (this.state.b2cSaveItineraryError) {
            return (
                <div className="Information">
                    <SpotlioIcon icon="status-closed" />
                    <p><IntlMessage id="b2c.save_itinerary.error_sending" /></p>
                </div>
            )
        } else if (this.state.successfullySavedB2CItinerary) {
            return (
                <div className="Information">
                    <SpotlioIcon icon="status-open" />
                    <p><IntlMessage id="b2c.save_itinerary.successfully_sent" /></p>
                </div>
            )
        } else if (this.state.b2cSaveItineraryLoading) {
            return (
                <div className="loadingb2c">
                    <CircularProgress />
                </div>
            )
        } else {
            return (
                <React.Fragment>
                    <p className="title"><IntlMessage id="b2c.save_itinerary.description" /></p>
                    <div className="GuestForm">
                        {
                            (getSystemSettings().app.cart.saveItinerary && getSystemSettings().app.cart.saveItinerary.mode && getSystemSettings().app.cart.saveItinerary.mode === "full") && (
                                <React.Fragment>
                                    <div className="formItem half">
                                        <h3><IntlMessage id="b2c.save_itinerary.first_name" /></h3>
                                        <TextField name="firstName" className="input" placeholder={LocaleAsString("b2c.save_itinerary.first_name")} value={this.state.b2cSaveItineraryForm.firstName} onChange={(e) => this.handleB2CSaveItineraryInput(e)} />
                                    </div>
                                    <div className="formItem half">
                                        <h3><IntlMessage id="b2c.save_itinerary.last_name" /></h3>
                                        <TextField name="lastName" className="input" placeholder={LocaleAsString("b2c.save_itinerary.last_name")} value={this.state.b2cSaveItineraryForm.lastName} onChange={(e) => this.handleB2CSaveItineraryInput(e)} />
                                    </div>
                                </React.Fragment>
                            )
                        }
                        <div className="formItem full">
                            <h3><IntlMessage id="b2c.save_itinerary.email" /></h3>
                            <TextField name="email" className="input" placeholder="example@example.com" value={this.state.b2cSaveItineraryForm.email} onChange={(e) => this.handleB2CSaveItineraryInput(e)} />
                        </div>
                    </div>
                </React.Fragment>
            )
        }
    }

    verifyDisabledSaveButtonForSaveItinerary() {
        const mailSettings = getSystemSettings().app.cart.saveItinerary;
        if (this.state.b2cSaveItineraryError || this.state.successfullySavedB2CItinerary) return false;
        if (this.state.b2cSaveItineraryLoading) return true;
        else {
            if (mailSettings) {
                if (mailSettings.mode === "full") {
                    if (!this.state.b2cSaveItineraryForm.firstName || !this.state.b2cSaveItineraryForm.lastName || !this.state.b2cSaveItineraryForm.email ) return true;
                    else return false;
                } else {
                    if (!this.state.b2cSaveItineraryForm.email) return true;
                    else return false;
                }
            } else {
                return true;
            }
        }
    }

    render(){

        if (this.state.loading === true){
            return(
                <div>
                    <SearchingScreen mode="loading" section="cart" css={{height: '200px'}}/>
                </div>
            )
        }

        if (this.state.itinerarySaved) {
            return (
                <React.Fragment>
                    <SEO title="Itinerary Saved" />
                    <div className="emptyCart">
                        <div className="summaryCart">
                            <div className="noItems">
                                <IntlMessage id="cart.modal.save-itinerary.saved" />
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            );
        }

        if (this.state.cart.length <= 0) {
            return (
                <React.Fragment>
                    <SEO title="Cart" />
                    <SearchingScreen message={<span className="emptyCartMessage">{getSystemSettings().head.phone ? <span className="phoneEmptyCart">{getSystemSettings().head.phone.phone} <br></br></span>: null} Your shopping cart is empty, <br></br> please proceed to build your itinerary or <br></br><IntlMessage id="cart.general.empty2_link" /></span>}mode="noresults" section="cart" css={{height: '200px'}} />
                </React.Fragment>
            );
        }

        return (
            <React.Fragment>
                <SEO title="Cart" />
                {this.props.readOnly || this.props.isDrawer ? null : <Breadcrumb withBottomMargin steps={this.state.steps.list} current={this.state.steps.current} />}
                <div className={(this.props.isDrawer ? "drawer " : " ") + "cartSection"}>
                    <div className="topBar">
                        <div className="title">
                            {LocaleAsString("skin.global.cart.title")}
                        </div>
                        <div className="itinerary-id">{
                            this.props.readOnly ?
                            <React.Fragment>
                                <span className="id">
                                    {LocaleAsString("checkout.your.itinerary") + " "} #{this.state.itineraryId} {" " + LocaleAsString("checkout.itinerary.successfully_saved")}
                                </span>
                                { this.renderSaveItineraryButton(false, 'top') }
                            </React.Fragment>
                            :
                            <React.Fragment>
                                <span className="id">
                                    {LocaleAsString("profile.itinerary.title")}
                                    {this.state.itineraryId}
                                </span>
                                { this.renderSaveItineraryButton(false, 'top') }
                            </React.Fragment>
                        }

                        </div>
                    </div>
                    <Products readOnly={this.props.readOnly} getPackage={this.getPackageUpselling.bind(this)} selectedPackage={this.state.selectedPackage} getBundle={this.getBundle.bind(this)} removePackage={this.removePackageModalOpen.bind(this)} deleteItem={this.removeItemModalOpen.bind(this)} cart={this.state.cart} />
                    <div className={(getSystemSettings().app.cart ? getSystemSettings().app.cart.upselling === false ? "noupselling " : " " : " ") + "bottom"}>
                        {getSystemSettings().app.cart ? getSystemSettings().app.cart.upselling === false ? null :
                        <div className="upselling">
                            <h3 className="topTitle">
                                {LocaleAsString("promocode.error.continue_shopping")}
                            </h3>
                            <div className="categories">
                                <TabGenerator upselling={true} />
                            </div>
                            <h3 className="bottomTitle">
                                {LocaleAsString("skin.whistler.cart.hotlinks_label2")}
                            </h3>
                        </div>
                        :
                        <div className="upselling">
                            <h3 className="topTitle">
                                {LocaleAsString("skin.whistler.cart.hotlinks_label")}
                            </h3>
                            <div className="categories">
                                <TabGenerator upselling={true} />
                            </div>
                            <h3 className="bottomTitle">
                                {LocaleAsString("skin.whistler.cart.hotlinks_label2")}
                            </h3>
                        </div>
                        }
                        <div className="summary">
                            {this.state.savings > 0 ? (
                                <div>
                                    <div className="savings">
                                        <IntlMessage id={
                                            getSystemSettings().app && getSystemSettings().app.cart && getSystemSettings().app.cart.savingsText 
                                            ?
                                            getSystemSettings().app && getSystemSettings().app.cart && getSystemSettings().app.cart.savingsText
                                            :
                                            "cart.labels.savings"
                                        } />
                                    </div>
                                    <div className="savings">
                                        <Currency float={true} value={this.state.savings}/>
                                    </div>
                                </div>
                            ) : null}
                            <div>
                                <div className="summaryName">
                                    {LocaleAsString("cart.labels.subtotal")}
                                </div>
                                <div className="summaryName">
                                    <Currency float={true} value={this.state.total}/>
                                </div>
                            </div>
                            {
                                <React.Fragment>
                                    <div onClick={()=>this.taxesModalOpen(true)} className="taxes">
                                        {LocaleAsString("cart.labels.taxes_fees")}:
                                    </div>
                                    <div className="summaryName">
                                        <Currency float={true} taxes={true} value={this.state.taxes}/>
                                    </div>
                                </React.Fragment>
                            }
                            <div>
                                <div className="summaryName">
                                    {LocaleAsString("cart.taxes.total")}
                                </div>
                                <div className="summaryName total">
                                    <Currency float={true} value={this.state.total + this.state.taxes}/>
                                </div>
                            </div>
                            <TotalDueNow base={this.state.total} />
                        </div>
                    </div>
                    <div className="extraComponents">
                    {
                        getSystemSettings().app.cart && getSystemSettings().app.cart.promocode
                        ?
                        <div className="attachPromocode">
                            <IntlMessage className="label" tag={true} id="Do you have a promo code?" />
                            <TextField variant="filled" label={LocaleAsString("Code")} fullWidth type="text" name="promocode" value={this.state.promocodeForm.code} onChange={this.handleFormChange('code', 'promocodeForm')} />
                            <Button className="apply" onClick={()=>this.applyPromocode()}>
                                <IntlMessage id="Apply promo code" />
                            </Button>
                            {this.state.promocodeForm.error && <div className="generalMessage error"><IntlMessage id="Code not valid" /></div>}
                        </div>
                        :
                        null
                    }
                    </div>
                    {this.state.needGuest && <div className="generalMessage error">Attach guest is required to proceed to checkout</div>}
                    <div className="checkout">
                        <SpotlioButton loading={this.state.loadingPayment} className="goToCheckout" onClick={()=>this.gotoRegister()}>
                            {LocaleAsString("cart.buttons.proceed_checkout")}
                            <SpotlioIcon icon={"feather-chevron-right"} size={24}/>
                        </SpotlioButton>
                        <div className="itinerary-id">
                            { this.renderSaveItineraryButton(true, 'bottom') }
                        </div>
                    </div>
                    {getSystemSettings().app.cart.refundPolicy ?
                        <div className="refundPolicy">
                            <IntlMessage id={getSystemSettings().app.cart.refundPolicy} />
                        </div>
                    : null}
                </div>
                <Dialog
                    open={this.state.removeItemModal}
                    title={LocaleAsString("cart.remove_item.title")}
                    className="deleteItem"
                    closeFn={this.removeItemModalOpen.bind(this, {}, false)}
                    footerContent={
                        <React.Fragment>
                            {(this.state.deletedItem.Quantity > 1 && this.state.deletedItem.Grouped === true) ?
                                <React.Fragment>
                                    <Button onClick={()=>this.handleDeleteItem(this.state.deletedItem.Quantity)} className="secondary">Remove All</Button>
                                    <Button onClick={()=>this.handleDeleteItem(this.state.amountToDelete)} className="secondary">Remove ({this.state.amountToDelete})</Button>
                                </React.Fragment>  :
                                <Button onClick={()=>this.handleDeleteItem()} className="secondary">Remove Product</Button>
                            }
                            <Button onClick={()=>this.removeItemModalOpen({}, false)} className="primary" autoFocus>Keep Item</Button>
                        </React.Fragment>
                    }
                >
                    <div className="body">
                        <div>{this.state.deletedItem.SupplierName}</div>
                        <div>{this.state.deletedItem.ProductName}</div>
                        {
                            (this.state.deletedItem.Quantity > 1 && this.state.deletedItem.Grouped === true)
                            ?
                            <div className="dropdowndelete">
                                {LocaleAsString("cart.remove_item.amount")}
                                <QuantitySelector
                                    showSymbol={'x'}
                                    max={this.state.deletedItem.Quantity}
                                    default={this.state.amountToDelete > 0 ? this.state.amountToDelete : 1}
                                    name="items"
                                    whenChange={(name, value)=>this.setState({amountToDelete: value})}
                                />
                            </div>
                            :
                            null
                        }
                    </div>
                </Dialog>

                <Dialog
                    open={this.state.removePackageModal}
                    title={LocaleAsString("cart.remove_item.title")}
                    className="deleteItem"
                    closeFn={this.removePackageModalOpen.bind(this, {}, false)}
                    footerContent={
                        <React.Fragment>
                            <Button onClick={()=>this.handleDeletePackage()} className="secondary">Remove Package</Button>
                            <Button onClick={()=>this.removePackageModalOpen({}, false)} className="primary" autoFocus>Keep Package</Button>
                        </React.Fragment>
                    }
                >
                    <div className="body">
                        <div>{this.state.deletedPackage.name}</div>
                    </div>
                </Dialog>

                <Dialog
                    open={this.state.itinerarySavedDiag}
                    title="Itinerary has been successfully saved!"
                    className="deleteItem"
                    closeFn={() => this.handleCloseItinerarySavedDiag()}
                    footerContent={
                        <React.Fragment>
                            <Button onClick={() => this.regenerateSessionAndRedirect()} className="secondary">
                                {LocaleAsString("b2b.travel_agent.go_to_dashboard")}
                            </Button>
                            <Button onClick={() => this.handleCloseItinerarySavedDiag()} className="primary" autoFocus>
                                {LocaleAsString("b2b.dialog.close")}
                            </Button>
                        </React.Fragment>
                    }
                >
                    <div className="body">
                        What would you like to do?
                    </div>
                </Dialog>

                <Dialog
                    open={this.state.taxesModal}
                    title="Taxes and fees"
                    className="taxes"
                    closeOnBackDrop={true}
                    closeFn={this.taxesModalOpen.bind(this, false)}
                    footerContent={
                        <React.Fragment>
                            <Button onClick={()=>this.taxesModalOpen(false)} className="default">
                                {LocaleAsString("cart.taxes.close")}
                            </Button>
                        </React.Fragment>
                    }
                >
                    <div className="body">
                        {this.state.taxesList.map((tax, idx) => {
                            return(
                                <div className="feesandtaxes" key={idx}>
                                    <div className="name">
                                        {tax.FeeTaxTypeName ? tax.FeeTaxTypeName : tax.name}
                                    </div>
                                    <div className="price">
                                        {tax.Amount === 0 || !tax.Amount ? <Currency currency='usd' float={true} value={tax.price}/> : <Currency currency='usd' float={true} value={tax.Amount}/>}
                                    </div>
                                </div>
                            )
                        })}
                        {
                            this.state.taxesList.length > 1
                            ?
                            <div className="totaltaxesandfees">
                                <p className="name">
                                    {LocaleAsString("activities.cart.total")}
                                </p>
                                <p className="price">
                                    <Currency currency='usd' float={true} value={this.state.taxes}/>
                                </p>
                            </div>
                            : null
                        }
                    </div>
                </Dialog>

                <Modal
                    open={this.state.addMoreModal}
                    title={this.state.addMoreModal ? this.state.modalComponent.ComponentName : null}
                    className="addMoreInfo"
                    noCloseButton={true}
                    closeFn={this.toggleAddMore.bind(this, false)}
                    footerContent={
                        <Button className="secondary" onClick={()=>this.setState({addMoreModal: false, modalComponent: {}, open: null})}><IntlMessage id="bundle.modal.close" /></Button>
                    }>
                    <div className="body">
                        {this.state.loadingAddMore !== false ? <CircularProgress /> :
                        <ListGroups
                            dateOfActivity={this.state.modalComponent.SearchDate}
                            maxQuantity={this.state.modalComponent.MaxQuantityTotal}
                            open={this.state.open}
                            toggleSupplier={this.toggleSupplier.bind(this)}
                            addToCart={this.addToPackage.bind(this)}
                            list={this.state.modalComponent.ComponentItems}
                        />}
                    </div>
                </Modal>

                <Modal
                    open={this.state.loadingBundle === true ? true : this.state.bundleObject.bundleModal[this.state.bundleObject.currentIndexModal]}
                    title={this.state.bundleObject.bundles.length > 0 && !this.state.loadingBundle ? this.state.bundleObject.bundles[this.state.bundleObject.currentIndexModal].bundleName : undefined}
                    className="bundleInfo"
                    noCloseButton={true}
                    closeFn={toggleBundleModal.bind(this, this.state.bundleObject, false)}
                    footerContent={
                        this.state.bundleObject.bundles.length > 0 ?
                        <React.Fragment>
                            {this.state.bundleObject.bundles[this.state.bundleObject.currentIndexModal].optional  !== false ?
                            <Button className="secondary" onClick={()=>this.setState({bundleObject: toggleBundleModal(this.state.bundleObject, false)})}><IntlMessage id="bundle.modal.close" /></Button>
                            : null}
                            <Button className="primary" onClick={()=>this.setState({loadingBundle: true}, () => addBundleProducts(this.state.bundleObject.bundles[this.state.bundleObject.currentIndexModal], (element)=>addBundleToCart(element).then( () => { this.getItinerary('add') })))}>Add</Button>
                        </React.Fragment>
                        : null
                }>
                <div className="body">
                    {this.state.bundleObject.bundles.length > 0 && !this.state.loadingBundle ?
                        <React.Fragment>
                            <div className="originalProduct">
                                <div>
                                    <IntlMessage id="bundle.modal.add_on_to" />
                                    {" " + this.state.bundleObject.productNameBundle}
                                </div>
                                {this.state.bundleObject.bundles[this.state.bundleObject.currentIndexModal].bundleDescription}
                                <p>{this.state.bundleObject.bundles[this.state.bundleObject.currentIndexModal].minAddOn !== 0 && this.state.bundleObject.bundles[this.state.bundleObject.currentIndexModal].minAddOn !== undefined ? <React.Fragment><IntlMessage id="bundle.min.add_on_to" /> : {" " + this.state.bundleObject.bundles[this.state.bundleObject.currentIndexModal].minAddOn}</React.Fragment> : null } {this.state.bundleObject.bundles[this.state.bundleObject.currentIndexModal].maxAddOn !== 0 && this.state.bundleObject.bundles[this.state.bundleObject.currentIndexModal].maxAddOn !== undefined ? <React.Fragment><IntlMessage id="bundle.max.add_on_to" /> : {" " + this.state.bundleObject.bundles[this.state.bundleObject.currentIndexModal].maxAddOn}</React.Fragment> : null}</p>
                            </div>
                            {this.state.bundleObject.bundles[this.state.bundleObject.currentIndexModal].childProducts ? this.state.bundleObject.bundles[this.state.bundleObject.currentIndexModal].childProducts.map((product, index) => {
                                return (
                                    <div className={"productBundle " + (index%2 === 0 ? 'even' : 'odd')}>
                                        <div className="productName">{product.productName}</div>
                                        <div className="stepper">
                                            <QuantitySelector
                                                showSymbol={'x'}
                                                whenChange={(name, value)=>this.setState({bundleObject: updateBundleAmount(value, this.state.bundleObject, index)})}
                                                default={this.state.bundleObject.bundles[this.state.bundleObject.currentIndexModal].childProducts[index].quantitySelected}
                                                value={this.state.bundleObject.bundles[this.state.bundleObject.currentIndexModal].childProducts[index].quantitySelected !== null ? this.state.bundleObject.bundles[this.state.bundleObject.currentIndexModal].childProducts[index].quantitySelected : 0}
                                                onlyDropDown={true}
                                                min={0}
                                                max={this.state.bundleObject.bundles[this.state.bundleObject.currentIndexModal].maxAddOn < product.quantityAvailable ? this.state.bundleObject.bundles[this.state.bundleObject.currentIndexModal].maxAddOn : product.quantityAvailable}>
                                            </QuantitySelector>
                                        </div>
                                        <Currency onlyOriginal={true} float={true} value={product.quantitySelected > 1 ? product.price * product.quantitySelected : product.price} />
                                    </div>
                                )
                            }) :
                            this.state.bundleObject.bundles[this.state.bundleObject.currentIndexModal].ProductList.map((product, index) => {
                                return (
                                    <div className={"productBundle " + (index%2 === 0 ? 'even' : 'odd')}>
                                        <div className="productName">{product.ProductName}</div>
                                        <div className="stepper">
                                            <NumericStepper
                                                whenChange={(name, value)=>this.updateBundleAmount(value, this.state.bundleObject.currentIndexModal, index)}
                                                default={0}
                                                onlyDropDown={true}
                                                min={0}
                                                max={product.Quantity}>
                                            </NumericStepper>
                                        </div>
                                        <Currency onlyOriginal={true} float={true} value={product.Price} />
                                    </div>
                                )
                            }) }
                            <span className="errorAmount">{this.state.bundleObject.incorrectAmount? <IntlMessage id="bundle.max.add_on_to_error" /> : null}</span>
                        </React.Fragment>
                    : <CircularProgress />}
                    </div>
                </Modal>
                <Dialog
                    open={this.state.b2cSaveItinerary}
                    title={LocaleAsString("b2c.save_itinerary.title")}
                    className="bundleInfo"
                    withCloseButton={true}
                    closeFn={() => this.handleOpenB2CSaveItinerary(false)}
                    footerContent={
                        <React.Fragment>
                            <Button className="primary" disabled={this.verifyDisabledSaveButtonForSaveItinerary()} onClick={() =>  (this.state.b2cSaveItineraryError || this.state.successfullySavedB2CItinerary) ? this.handleOpenB2CSaveItinerary(false) : this.saveItinerary('b2c')}>
                                <IntlMessage id={
                                    (this.state.b2cSaveItineraryError || this.state.successfullySavedB2CItinerary)
                                    ? 'b2c.save_itinerary.close_button'
                                    : 'b2c.save_itinerary.save_button'
                                } />
                            </Button>
                        </React.Fragment>
                }>
                    <div className="SaveItinerary">
                        { this.handleRenderSaveItineraryModalContent() }
                    </div>
                </Dialog>
            </React.Fragment>
        );

    };
}
